import { selectEntityById } from 'ducks/entities/selectors'

export const selectSpammerById = (state, id, store) =>
  selectEntityById(state, 'spammer', id, store)
